import { render, staticRenderFns } from "./NewsletterSuccess.vue?vue&type=template&id=5452f17a&"
import script from "./NewsletterSuccess.vue?vue&type=script&lang=js&"
export * from "./NewsletterSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports